import { render, staticRenderFns } from "./OurTechApproachVideo.vue?vue&type=template&id=651f9b30&"
import script from "./OurTechApproachVideo.vue?vue&type=script&lang=js&"
export * from "./OurTechApproachVideo.vue?vue&type=script&lang=js&"
import style0 from "./OurTechApproachVideo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports